export default {"src":"/assets/_next/static/media/powered_by_stripe.f4d7aa73.svg","height":26,"width":119,"blurWidth":0,"blurHeight":0};